export default {
  beforeRouteLeave(to, from, next) {
    if (to.params.allow) {
      next()
    } else {
      if (this.form ? this.checkIfFormChanged() : this.formComponent.checkIfFormChanged()) {
        // Method from '@lib/mixins/modal-form'
        this.$modal.show('form-leave-confirm', {
          on: {
            leave: next,
          },
        })
      } else {
        next()
      }
    }
  },
}
